import * as React from 'react';

const Arrow = ({
  fill = '#212721',
  width = '18',
  height = '11'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 18 11">
    <g
      id="Screens"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="B---01-Work-Station---01.01-Hover"
        transform="translate(-290 -252)"
        fill={fill}
        fillRule="nonzero">
        <g id="Accessories" transform="translate(135 242)">
          <g id="Headline">
            <path
              d="m164 10.586 8.707 8.707a1 1 0 0 1-1.32 1.497l-.094-.083L164 13.415l-7.293 7.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094L164 10.586z"
              id="down-arrow"
              transform="matrix(1 0 0 -1 0 31.586)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Arrow;
